<template>
    <div>
        <v-layout wrap>
            <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                <v-select 
                    label="Chọn kho"
                    v-validate="'required'"
                    :items="lstWarehouse"
                    item-text="categoryName"
                    item-value="categoryId"
                    @change="onChangeWh"
                    clearable
                />
            </v-flex>
        </v-layout>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="fixedAssetsId"
            search-url="/fixedAssets/detailReport"
            form-type="intable"
            :customCreateNew="true"
            @createNew="openCreate"
            @viewItem="viewItem"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            :acceptDelete="false"
            :acceptView="true"
            :acceptEdit="false"
            :hiddenFields="hiddenFields"
        >
        </c-search-form>
        <tranfer-history
            :propsItem="item"
            :dialog="visibleDialog"
            @close="closeDialog"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import { cateContants } from "@/constants";
import axios from "axios";
import { message } from "../../../shared/message";
import TranferHistory from "./TranferHistory.vue";

export default {
    name: "fixed-assets-tranfer-list",
    components: { CSearchForm, TranferHistory },
    data: () => {
        return {
            formName: "Điều chuyển tài sản",
            item: null,
            visibleDialog: false,
            timeReload: 0,
            lstWarehouse: [],
            hiddenFields: {
                warehouseId: null,
            },
            warehouseId: null,
            lstLocation: [],
            lstDepartment: [],
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "fixedAssetsCode",
                    text: "Mã quản lý",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: cateContants.fixedAssetsStatus,
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "locationId",
                    text: "Địa điểm hiện tại",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "locationId",
                    items: [],
                    itemText: "categoryName",
                    itemValue: "categoryId",
                },
                {
                    value: "departmentId",
                    text: "Bộ phận hiện tại",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "departmentId",
                    items: [],
                    itemText: "deptName",
                    itemValue: "deptId",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    width: "10%",
                    sortable: false,
                    compound: true,
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        this.getWarehouse();
        this.getLocation();
        this.getDepartment();
    },

    methods: {
        openCreate: function () {
            this.$router.push({ path: '/fixedAssetsTranfer/create' });
        },
        closeDialog: function () {
            this.visibleDialog = false;
            this.item = null;
        },
        viewItem(item) {
            this.item = item;
            this.visibleDialog = true;
        },
        getWarehouse() {
            axios.post(
                process.env.VUE_APP_API_URL +
                "/category/listByType?type=WAREHOUSE&description=1"
            )
                .then((data) => {
                    if (data.length > 0) {
                        this.lstWarehouse = data;
                    }
                });
        },
        getLocation() {
            axios.post(
                    process.env.VUE_APP_API_URL + "/category/listByTypeOrderByCodeAsc?type=OFFICE_LOCATION"
                )
                .then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstLocation = data;
                            let itemFields = this.fields.filter(function (e) {
                                return e.name == "locationId";
                            });
                            if (itemFields != undefined && itemFields.length > 0) {
                                itemFields[0].items = data;
                            }
                        }
                    }
                );
        },
        getDepartment() {
            axios.post(process.env.VUE_APP_API_URL + "/department/search?pageSize=-1&page=-1", {})
            .then(
                (data) => {
                    if (data.items) {
                        this.lstDepartment = data.items;
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "departmentId";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data.items;
                        }
                    }
                }
            );
        },
        onChangeWh(warehouseId) {
            this.hiddenFields = Object.assign(this.hiddenFields, {warehouseId: warehouseId});
            this.$store.commit("fixedAssets/setWarehouseId", warehouseId);
        },
    },

    destroyed() {},
};
</script>
